import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

import { RightActionBlockHeader } from "../RightActionBlockHeader";

interface HeaderProps {
  onClose: () => void;
}

export const Header = ({ onClose }: HeaderProps) => (
  <RightActionBlockHeader
    title={t("header_v3.connect.title")}
    actions={
      <Tooltip content={t("header_v3.close")}>
        <IconButton
          icon="cross"
          variant="ghost"
          size="md"
          onClick={onClose}
          aria-label={t("header_v3.close")}
          data-testid="connect-panel-close-button"
        />
      </Tooltip>
    }
  />
);
